export default {
  panzoom: {
    helpText: 'Raccourcis utiles :\n'
      + 'Ctrl + molette de la souris - zoom avant/arrière\n'
      + 'Ctrl + Clic gauche de la souris + glisser - déplacer la zone\n',
  },
};
